import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Spin } from 'antd'
import {withTranslation} from 'react-i18next'
import ResourcePoolSearchForm from './ResourcePoolSearchForm'
import ResourcePoolSearchResult from './ResourcePoolSearchResult'
@inject('marketingResourcePoolStore')
@observer
class TemplateList extends Component {
  state = {
  }
  formRef = React.createRef()
  componentDidMount() {
  }
  render() {
    const { marketingResourcePoolStore, addModalVisible, handleCancel, type, smsType, isSelect, record, poolObj, marketGroupId, t } = this.props
    const { isFetchingDetails, isFetchingEdit, detailsObj } = marketingResourcePoolStore
    return (
      <Modal
        title={`${t('menu.resourcePool')}-${detailsObj?.resourcePoolName}`}
        closable={true}
        visible={addModalVisible}
        onCancel={handleCancel}
        maskClosable={false}
        destroyOnClose={true}
        width={'95%'}
        centered
        footer={false}
        className='shortLinkModel'
      >
        <Spin spinning={isFetchingDetails || isFetchingEdit}>
          <ResourcePoolSearchForm handleCancel={handleCancel} type={type} smsType={smsType} poolObj={poolObj} marketGroupId={marketGroupId} record={record} isSelect={isSelect} />
          <ResourcePoolSearchResult record={record} />
        </Spin>
      </Modal>
    )
  }
}

export default withTranslation()(TemplateList)
